import { faCog } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const SettingsIcon = (props: { color: string }) => {
  return (
    <FontAwesomeIcon icon={faCog} color={props.color} />
  )
}
